import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { compose } from 'redux';

import { FormattedMessage, injectIntl } from '../../../util/reactIntl';
import { Button } from '../../../components';
import css from '../EditUserInfoModal.css';
import TooltipSectionInfo from './TooltipSectionInfo';
import RiderInterestsFormFields from '../../RiderInterestsFormFields/RiderInterestsFormFields';

const EditUserInterestSection = ({ intl, ...restProps }) => {
    return (
        <FinalForm
            {...restProps}
            render={fieldRenderProps => {
                const {
                    handleSubmit,
                    values,
                    valid,
                    updateInProgress,
                    pristine,
                    initialValues,
                    form,
                } = fieldRenderProps;
                const { interest: initialInterest } = initialValues || {};
                const disabled = !values.interest || !valid || pristine;

                return (
                    <>
                        <RiderInterestsFormFields form={form} values={values} />

                        <div className={css.userDataProtectedMessage} />
                        <footer>
                            <TooltipSectionInfo
                                headingId="EditUserInterestSection.sideNoteTooltipHeading"
                                descriptionId="EditUserInterestSection.sideNoteTooltipDesc"
                                sidenoteId="EditUserForms.updateAvailabilitySideNote"
                            />

                            <Button
                                disabled={disabled}
                                onClick={handleSubmit}
                                inProgress={updateInProgress}
                            >
                                <FormattedMessage
                                    id={`ProfileSettingsForm.editUserInfoAction-${
                                        initialInterest && initialInterest.length
                                            ? 'edit'
                                            : 'userExperience'
                                    }`}
                                />
                            </Button>
                        </footer>
                    </>
                );
            }}
        />
    );
};

export default compose(injectIntl)(EditUserInterestSection);
